import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { RoleDetailedDto, RolesClient } from '@unity/clients';
import { AuthorizeDirective } from '@unity/directives/authorize.directive';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';

@Component({
  selector: 'unity-grid-agency-role-shared',
  standalone: true,
  imports: [KENDO_GRID, AuthorizeDirective, GridSharedComponent, LinkGridcellSharedComponent, TypedDirective],
  templateUrl: './grid-agency-role-shared.component.html',
  styleUrl: './grid-agency-role-shared.component.scss',
})
export class GridAgencyRoleSharedComponent extends AbstractGridComponent<RoleDetailedDto> {
  private readonly rolesClient = inject(RolesClient);

  public readonly $agencyId = input<number | undefined>(undefined, { alias: 'agencyId' });

  protected resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const maybeAgencyId = this.$agencyId();
      return query ? { query, maybeAgencyId } : undefined;
    },
    stream: ({ params: { query, maybeAgencyId } }) =>
      this.rolesClient.getAllAsDetailed(maybeAgencyId, query.page, query.pageSize, query.orderBy, query.filter),
  });
}
